import { Form, Select } from "antd";
import React from "react";

export default function SelectBoxField(props) {

    const { data = {}, form, contact = {}, label_class = "", label_help_class = "", label_description_class = "" } = props

    const {
        id = "",
        label = "Select",
        type = "select",
        description = "",
        options = [{ label: "" }]
    } = data;

    let defaultValue = (contact.hasOwnProperty([id])) ? contact[id] : options[0].label;

    return (
        <Form.Item initialValue={defaultValue} extra={(description && <span className={label_description_class}>{description}</span>)} label={<div className={label_class}>{label}</div>} name={id} >
            <Select dropdownMatchSelectWidth >
                {options.map((item, index) => {
                    return (<Select.Option key={index} value={item.label}>{item.label}</Select.Option>)
                })}
            </Select>
        </Form.Item>
    )
}